export default __webpack_public_path__ + "static/media/creatura-logos_horizontal.08f455c5.png";